import { render, staticRenderFns } from "./EmployeeGrantAdd.vue?vue&type=template&id=b59ca3b0&"
import script from "./EmployeeGrantAdd.vue?vue&type=script&lang=js&"
export * from "./EmployeeGrantAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports